// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3JQtT","inner":"Footer_inner__2wIN6"};